import * as React from 'react';

export function IconPriceChart() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 80 80">
      <path fill="#0468FF" fillOpacity=".1" d="M32 8h16v8h16v64H0V24h16v-8h16V8z" />
      <path fill="#0468FF" d="M16 56l24-16 16 16 24-24v48H16V56z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M54 71.927V74h4v-2l22-22v-3.5L56.98 70h-1.955L42 56.635V54h-4v2.15L16 71v2l22.789-15h1.772L54 71.927z"
        clipRule="evenodd"
      />
    </svg>
  );
}
